class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.interval = +this.dataset.interval; // interval in hours
    this.initialStartDate = this.dataset.initialStartDate;

    this.intervalHours = this.interval;
    this.intervalMs = this.intervalHours * 60 * 60 * 1000;

    // Set start and end dates
    this.startDate = new Date(`${this.initialStartDate}T00:00:00`);
    this.endDate = this.appendHoursToDate(this.startDate, this.intervalHours);

    this.updatedDates = this.updateDates();
  }

  connectedCallback() {
    this.startDate = this.updatedDates[0];
    this.endDate = this.updatedDates[1];

    this.updateCountdown();
    setInterval(this.updateCountdown.bind(this), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();

    if (now >= this.endDate.getTime()) {
      this.updatedDates = this.updateDates();
      this.startDate = this.updatedDates[0];
      this.endDate = this.updatedDates[1];
    }

    const timeLeft = this.endDate - now;

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    this.querySelector('#days').innerHTML = String(days).length > 1 ? days : `0${days}`;
    this.querySelector('#hours').innerHTML = String(hours).length > 1 ? hours : `0${hours}`;
    this.querySelector('#minutes').innerHTML = String(minutes).length > 1 ? minutes : `0${minutes}`;
    this.querySelector('#seconds').innerHTML = String(seconds).length > 1 ? seconds : `0${seconds}`;
  }

  updateDates() {
    const cycles = Math.floor((new Date().getTime() - this.startDate.getTime()) / this.intervalMs);

    if (cycles > 0) {
      this.startDate = this.appendHoursToDate(this.startDate, this.intervalHours * cycles);
      this.endDate = this.appendHoursToDate(this.startDate, this.intervalHours);
    }

    return [this.startDate, this.endDate];
  }

  appendHoursToDate(date, hours) {
    let newDate = new Date(date);
    return new Date(newDate.getTime() + hours * 60 * 60 * 1000);
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
